import { Directive, ChangeDetectorRef, HostListener } from '@angular/core';

/**
 * Ensures Action dropdown opens on first click (change detection).
 * Pair with `ActionDropdownOverlayController` / `openInlineTableActionDropdown` in
 * `shared/utils/action-dropdown-overlay.sync.ts` so fixed menus stay aligned on scroll.
 */
@Directive({
  selector: '[appActionDropdownTrigger]',
  standalone: true,
})
export class ActionDropdownTriggerDirective {
  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener('click')
  onHostClick(): void {
    setTimeout(() => this.cdr.detectChanges(), 0);
  }
}
